const colors = {
    primary: '#3e64ff',
    secondary: 'green',
    black: '#000000',
    white: '#ffffff',
    danger: '#f72585',
    success: '#4cc9f0',
}

export default colors;